<template>
	<vx-card class="packs-crear" title="Registrar código para descuento">

		<vs-button
            class="py-1 px-3 d-flex align-items-center"
            color="danger"
            type="filled"
            @click="$router.push('/codigos-descuento')"
            >
            <feather-icon
                icon="ArrowLeftCircleIcon"
                svgClasses="stroke-current"
                class="mr-2"
              />
            Regresar
            </vs-button
        >
		
		<section class="mt-5" v-if="item.cuponId">
			<div class="vx-row">

				<div class="vx-col sm:w-3/4 w-full mb-2">
					<div class="vx-row">

						<div class="vx-col w-full mb-5">
							<label for="estado">Estado de cupón</label>

			                <v-select
				                id="estado"
				                :options="estados"
				                :dir="$vs.rtl ? 'rtl' : 'ltr'"
				                v-model="item.estado"
				            />
			            </div>

		    			<div class="vx-col w-full mb-5">
			                <vs-input
			                  class="w-full"
			                  label-placeholder="Código"
			                  v-model="item.codigo"
			                />
			            </div>


			            <div class="vx-col sm:w-1/2 mb-5">
			                <label for="fechaInicio">Fecha inicial</label>

			                <datepicker id="fechaInicio" v-model="item.fechaInicio" :language="langDatePicker"></datepicker>
			            </div>

			            <div class="vx-col sm:w-1/2 w-full mb-5">
		                    <label for="fechaVigente">Fecha final</label>

			                <datepicker id="fechaVigente" v-model="item.fechaVigente" :language="langDatePicker"></datepicker>
		                </div>

		                <div class="vx-col sm:w-1/2 mb-5">
			                <vs-input
			                  type="number"
			                  min="0"
			                  step="1"
			                  class="w-full"
			                  label-placeholder="Unidades"
			                  v-model="item.unidades"
			                />
			            </div>

			            <div class="vx-col sm:w-1/2 w-full mb-5">
		                    <vs-input
			                  type="number"
			                  min="0"
			                  class="w-full"
			                  label-placeholder="Porcentaje a descontar"
			                  v-model="item.montoDescuento"
			                />
		                </div>
			        </div>
			    </div>
    		</div>
		</section>

		<section>
			<div class="d-flex justify-content-end">
				<vs-button
		            class="custom-btn d-flex justify-content-center align-items-center mr-3"
		            color="success"
		            :disabled="actualizando || !validate"
		            @click="actualizar()"
		            >
		            {{ actualizando ? 'Actualizando...' : 'Actualizar' }}

		            <feather-icon
			            icon="ArrowRightIcon"
			            svgClasses="stroke-current"
			            @click="actualizar()"
			         />
		            </vs-button
		        >
			</div>
		</section>
	</vx-card>
</template>

<script>
	import GetCuponCodigo from '@/apollo/queries/codigos-descuentos/GetCuponCodigo.gql'
	import updateCupones from '@/apollo/mutations/codigos-descuentos/updateCupones.gql'

	import Datepicker from 'vuejs-datepicker';
	import {en, es} from 'vuejs-datepicker/dist/locale'

	import vSelect from "vue-select";

	export default {
		data() {
			return {
				codigo: this.$route.params.codigo,
				cargaInicial: true,
				datePickerFormat: 'MMMM yyyy',
				langDatePicker: es,
				actualizando: false,
				estados: [
			        { id: "0", label: "Cupón desactivado" },
			        { id: "1", label: "Cupón activado" }
			    ],
				item: {}
			}
		},
		mounted() {
			this.getItem()
		},
		components: {
			Datepicker,
			vSelect
		},
		methods: {
			async getItem() {
				const response = await this.$apollo.query({
					query: GetCuponCodigo,
					fetchPolicy: 'no-cache',
					variables: {
						codigo: this.codigo
					}
				})

				this.item = response.data.GetCuponCodigo

				this.item.estado = this.item.estado.toString()

				let tipo = this.estados.find( (item) => parseInt(item.id) === parseInt(this.item.estado) )

	            if (tipo) {
	            	this.item.estado = tipo;
	            }

				this.item.fechaInicio = this.$dayjs(this.item.fechaInicio).format()
				this.item.fechaVigente = this.$dayjs(this.item.fechaVigente).format()
			},
		    actualizar() {
		    	this.actualizando = true

		    	let { cuponId, estado, codigo, fechaInicio, fechaVigente, unidades, montoDescuento } = this.item

		    	let input = {
		    		cuponId,
		    		estado: parseInt(estado.id),
    				codigo,
    				fechaInicio: this.$dayjs(fechaInicio).format('YYYY-MM-DD'),
    				fechaVigente: this.$dayjs(fechaVigente).format('YYYY-MM-DD'),
    				unidades: parseInt(unidades),
    				montoDescuento: parseFloat(montoDescuento)
    			}

		    	this.$apollo.mutate({
		    		mutation: updateCupones,
		    		variables: {
		    			input
		    		}
		    	})
		    	.then(() => {
		    		this.$router.push("/codigos-descuento");

			          this.actualizando = false;

			          this.$vs.notify({
			            title: "Código actualizado",
			            color: "success",
			            position: "top-right",
			          });
		    	})
		    }
		},
		computed: {
			validate() {
				let status = false

				let { codigo, fechaInicio, fechaVigente, unidades, montoDescuento } = this.item

				if(codigo && fechaInicio && fechaVigente && unidades && montoDescuento) {
					status = true
				}

				return status
			}
		}
	}
</script>

<style lang="scss">
.packs-crear {
	.v-select.vs--single.vs--searchable {
		width: 300px;
	}

	.table-image {
		width: 30px;
		height: 30px;
	}

	.vs-component.con-vs-checkbox.vs-checkbox-primary.vs-checkbox-default {
		width: 50px;
	}
}

.small {
	font-size: .9em;
}
</style>